// extracted by mini-css-extract-plugin
export default {"base":"PreviewRemove_base__ZgEcU"};